export enum JobTypeEnum {
  NORMAL = 1,
  PATIENT_SITTING = 2,
  ONE_TO_ONE = 3,
}
